<template>
  <div
    class="confirmation"
    :class="{
      active: opened == true,
      'confirmation--centered': centered == true
    }"
  >
    <div class="confirmation__overlay" />
    <div class="confirmation__box">
      <div class="confirmation__box__text text-left">
        <div class="d-flex align-items-center">
          <!--div class="atom-icon mr-0">
            <img src="@/assets/icons/actions/ico-ico-delete-red.svg">
          </div-->
          <h4 class="font-weight-bolder mb-3">
            {{ $t("necoSeNepovedlo") }}
          </h4>
        </div>
        <ul class="">
          <li class="text-left gray-text-light mb-0 text-small">
            <p class="mb-0">
              {{ $t("neplatnyPrihlasovaciToken") }} <br />
              {{ $t("poKliknutiNaOkDojdeKPokusuOJehoObnoveni") }}
            </p>
          </li>
        </ul>
      </div>
      <div
        class="confirmation__box__buttons d-flex align-items-center justify-content-end"
      >
        <button class="btn btn-primary" @click="close()">
          {{ $t("ok") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
//import _ from "lodash";
//import axios from "axios";
export default {
  props: {
    opened: Boolean,
    items: Array,
    centered: Boolean
  },
  data() {
    return {};
  },
  computed: {},
  watch: {
    opened() {}
  },
  mounted() {
    if (this.opened) {
      this.$emit("close");
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped></style>
